import { Loader } from '@crehana/compass.ui';

import { useTranslationCreateAndEditEmailTemplates } from '@/shared/components/email-component/hooks/use-translations';

// Loading component to display a loading state.
const Loading = () => {
  const { t } = useTranslationCreateAndEditEmailTemplates();

  return (
    <section className="tw-dark tw-flex tw-flex-col tw-gap-0.8 tw-h-full tw-items-center tw-place-content-center tw-w-full">
      {/* Loader component to show a loading spinner */}
      <Loader size="s" />
      {/* Translated text that indicates loading is in progress */}
      <p>{t('NOTIFICATION_LOADING')}</p>
    </section>
  );
};

export default Loading;
